import YTPlayer from 'yt-player';

export default {
  init() {

  },
  finalize() {

    const $ssgVideoBanner = $('.ssg-banner-video');

    if ($ssgVideoBanner.length > 0) {

      const $videoItem = $ssgVideoBanner.find('.video-item');
      const videoBannerId = $videoItem.prop('id');

      const player = new YTPlayer(`#${videoBannerId}`, {
        autoplay: true,
        controls: false,
        keyboard: false,
        annotations: false,
        fullscreen: false,
        modestBranding: true,
        related: false,
        playsInline: true,
      });

      player.load($videoItem.data('vid-id'));
      player.mute();

      player.on('cued', () => {
        player.play();
      });

      player.on('playing', () => {
        $ssgVideoBanner.find('.video-splash').addClass('hide');
      });

      player.on('ended', () => {
        // repeat.
        player.play();
      });

    }

  },
}


// WEBPACK FOOTER //
// ./scripts/partials/ssg/ssgBannerVideo.js